import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './root-saga';
import queueReducer from '../queue/ducks/slice';
import exploreReducer from '../explore/ducks/slice';
import appReducer from './app-slice';
import storeAdminReducer from '@/storeAdmin/ducks/slice';
import globalAdminReducer from '@/review/ducks/slice';
import dealerReducer from '../dealerProfile/ducks/slice';

const sagaMiddleware = createSagaMiddleware();

const combinedReducer = combineReducers({
  queue: queueReducer,
  explore: exploreReducer,
  app: appReducer,
  store: storeAdminReducer,
  globalAdmin: globalAdminReducer,
  dealer: dealerReducer
});

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === 'RESET') {
    state = {};
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: [sagaMiddleware]
});
sagaMiddleware.run(rootSaga);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
